// chat-ui/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import { AuthProvider } from './context/AuthContext';
import './styles/App.css'; // Basic styling

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Add other routes if needed later */}
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;